import React, { useEffect, useRef } from 'react';

import { createClasses } from '@kp/react-ui';

import { ChatMessage } from './ChatMessage';
import { LoadingIndicator } from './LoadingIndicator';
import { SuggestedPrompts } from './SuggestedPrompts';
import { ChatMessage as ChatMessageType } from './types';

const classes = createClasses({
  root: {
    flex: 1,
    overflowY: 'auto',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  emptyState: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
});

interface ChatMessagesProps {
  messages: ChatMessageType[];
  isLoading: boolean;
  loadingText: string;
  onSelectPrompt: (text: string) => void;
  onRetry: (failedId: string) => void;
}

export const ChatMessages: React.FC<ChatMessagesProps> = ({
  messages,
  isLoading,
  loadingText,
  onSelectPrompt,
  onRetry,
}) => {
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isLoading]);

  const isEmpty = messages.length === 0;

  return (
    <div className={classes.root}>
      {isEmpty ? (
        <div className={classes.emptyState}>
          <SuggestedPrompts onSelect={onSelectPrompt} />
        </div>
      ) : (
        <>
          {messages.map((message) => (
            <ChatMessage key={message.id} message={message} onRetry={onRetry} />
          ))}
          {loadingText && <LoadingIndicator text={loadingText} />}
        </>
      )}
      <div ref={bottomRef} />
    </div>
  );
};
